import React from 'react';
import {
  Tab,
  ListButton,
  FunctionField,
  EditButton,
  TabbedShowLayout,
  ShowController,
  ShowView,
  SelectField,
} from 'react-admin';
import CardActions from '@material-ui/core/CardActions';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import BankLinkConfigShow from './BankLinkConfig_Show';
import BankTransferConfigShow from './BankTransferConfig_Show';
import { ConfigTypeEnum } from '../../helpers/mappings';

const cardActionStyle = {
  marginTop: -5,
  float: 'right',
};

const adminLevel = getAdminLevel();

const Actions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN && <EditButton basePath={basePath} record={data} />}
    <ListButton basePath={basePath} />
  </CardActions>
);

export default props => (
  <ShowController {...props}>
    {controllerProps => (
      <ShowView
        {...props}
        {...controllerProps}
        title=""
        actions={<Actions />}
      >
        <TabbedShowLayout>
          <Tab label="Configuration">
            <SelectField
              label="Configuration Type"
              source="configType"
              choices={ConfigTypeEnum}
              readOnly
            />
            <FunctionField
              label="Application Configuration"
              addLabel={false}
              render={record => record.configType === 'bank_link' && <BankLinkConfigShow record={record} />}
            />
            <FunctionField
              label="Application Configuration"
              addLabel={false}
              render={record => record.configType === 'bank_transfer' && <BankTransferConfigShow record={record} />}
            />
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    )}
  </ShowController>
);



// WEBPACK FOOTER //
// ./src/components/Config/Show.jsx